<template>
  <v-card
      :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile, 'by-center': center}"
      :elevation="$vuetify.breakpoint.mobile ? 1 : 2"
  >
    <v-list-item :dense="$vuetify.breakpoint.mobile">
      <v-list-item-avatar>
        <slot name="image">
          <v-icon
              v-if="icon"
              class="white--text"
              :class="color"
          >
            {{icon}}
          </v-icon>
        </slot>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{title}}</v-list-item-title>
        <v-list-item-subtitle>
          <slot name="subtitle"></slot>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <slot name="tabs"></slot>

    <v-card-text>
      <slot></slot>
    </v-card-text>

    <v-card-actions v-if="$slots.actions">
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'InterfaceCard',
  props: {
    center: {
      default: false,
      type: Boolean
    },
    color: {
      default: 'primary',
      type: String
    },
    icon: {
      type: String
    },
    image: {
      type: String
    },
    title: {
      required: true,
      type: String
    },
    subtitle: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>
